import PropTypes from "prop-types";
import ErrorIcon from "/public/images/icons/inputError.svg?react";

export default function TextArea({
  name,
  onChange,
  required,
  placeholder,
  label,
  error,
  className,
  ref,
  defaultValue,
  ...props
}) {
  return (
    <label className="flex flex-col gap-1">
      {label && (
        <div>
          <span className="text-sportsBlack font-medium text-base leading-[26px mb-1]">
            {label}
            {required && "*"}
          </span>
        </div>
      )}

      <div className="relative block">
        <textarea
          name={name}
          onChange={onChange}
          required={required}
          placeholder={placeholder}
          defaultValue={defaultValue}
          ref={ref}
          {...props}
          className={`
            ${error && "border-sportsRed !border-2"} 
            focus:outline-sportsYellow h-[120px] 
            placeholder:text-[#727272] 
            bg-sportsLightGrey w-full border-solid border-[1px] border-[#E3E3E3] rounded-[4px] p-3 text-base leading-[26px] text-[#101820] ${className}
          `}
        ></textarea>
        {error && (
          <span className="absolute bottom-4 right-4 cursor-pointer">
            <ErrorIcon className="w-6 h-6" />
          </span>
        )}
      </div>
      {error && (
        <p className="text-sportsRed text-base leading-[24px]">{error}</p>
      )}
    </label>
  );
}

TextArea.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  className: PropTypes.string,
  ref: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};
